"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PENDING = 'pending';
exports.VERIFIED = 'verified';
exports.REJECTED = 'rejected';
exports.paymentStatus = [exports.PENDING, exports.VERIFIED, exports.REJECTED];
//# sourceMappingURL=paymentStatus.js.map